import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline + user-confirmed update
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // When a new SW is found, notify the app via a custom event so
        // <PWAUpdateBanner> can render a "Refresh now" prompt. We do NOT
        // auto-skipWaiting anymore — a mid-typing reload was bad UX and
        // hid the fact that a new version had shipped.
        const notifyIfWaiting = () => {
          if (reg.waiting && navigator.serviceWorker.controller) {
            window.dispatchEvent(
              new CustomEvent("sonspeak:sw-update", { detail: { registration: reg } })
            );
          }
        };
        // Case 1: a new worker is already waiting when we register.
        notifyIfWaiting();
        // Case 2: a new worker gets installed while this tab is open.
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(
                new CustomEvent("sonspeak:sw-update", { detail: { registration: reg } })
              );
            }
          });
        });
      })
      .catch(() => { /* ignore registration failures */ });

    // Reload once the (user-confirmed) new SW takes control.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
